export default __webpack_public_path__ + "static/media/Shadow's Boots of the Deceiver.68e643f8.jpg";